'use client';

import Script from 'next/script';

export default function GoogleBadgNew() {
  return (
    <Script
      id="merchantWidgetScript"
      src="https://www.gstatic.com/shopping/merchant/merchantwidget.js"
      strategy="afterInteractive"
      onLoad={() => {
        window.merchantwidget.start({
          position: 'LEFT_BOTTOM',
          sideMargin: 16, // 左右边距 (出来的效果跟实际值一样)
          bottomMargin: 0, // 底部边距 (设置成0，出来的效果刚好是 16px)
        });
      }}
    />
  );
}
